import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

const LoadingGame = ({ message = "Loading game..." }) => {
    return (
        <div className="flex flex-col items-center justify-center p-8">
            <FontAwesomeIcon 
                icon={faSpinner} 
                className="text-4xl text-blue-500 animate-spin mb-4" 
            />
            <p className="text-gray-600 dark:text-gray-400">{message}</p>
        </div>
    );
};

export default LoadingGame;
